import {
  IconButton,
  Stack,
  Badge,
  Popover,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";

export default function DataInicioFimFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [periodo, setPeriodo] = useState(localStorage.getItem('periodoSelecionado') || "");


  // estados internos (debounce)
  const [dataInicioLocal, setDataInicioLocal] = useState(props.dataInicio || "");
  const [dataFimLocal, setDataFimLocal] = useState(props.dataFim || "");


  const open = Boolean(anchorEl);

  const onClose = () => setAnchorEl(null);

  // // formatar YYYY-MM-DD
  // const formatar = (data) => data.toISOString().split("T")[0];
  const formatar = (data) => {
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();

    return `${dia}-${mes}-${ano}`;
  };

  //periodo efect
  useEffect(() => {
    localStorage.setItem('periodoSelecionado', periodo);
  }, [periodo]);

  // debounce effect
  useEffect(() => {
    const timer = setTimeout(() => {
      props.setDataInicio(dataInicioLocal);
      props.setDataFim(dataFimLocal);
    }, 2000);

    return () => clearTimeout(timer);
  }, [dataInicioLocal, dataFimLocal]);


  // lógica dos períodos
  const aplicarPeriodo = (tipo) => {
    const hoje = new Date();
    let inicio = new Date();
    let fim = new Date();

    switch (tipo) {
      case "hoje":
        break;

      case "ontem":
        inicio.setDate(hoje.getDate() - 1);
        fim = new Date(inicio);
        break;

      case "7dias":
        inicio.setDate(hoje.getDate() - 6);
        break;

      case "30dias":
        inicio.setDate(hoje.getDate() - 29);
        break;

      case "semana":
        const diaSemana = hoje.getDay();
        inicio.setDate(hoje.getDate() - diaSemana);
        break;

      case "mes":
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        break;

      case "trimestre":
        const mes = hoje.getMonth();
        const trimestreInicio = Math.floor(mes / 3) * 3;
        inicio = new Date(hoje.getFullYear(), trimestreInicio, 1);
        fim = new Date(hoje.getFullYear(), trimestreInicio + 3, 0);
        break;

      case "semestre":
        const mesSem = hoje.getMonth();
        const semInicio = Math.floor(mesSem / 6) * 6;
        inicio = new Date(hoje.getFullYear(), semInicio, 1);
        fim = new Date(hoje.getFullYear(), semInicio + 6, 0);
        break;

      default:
        return;
    }

    setDataInicioLocal(formatar(inicio));
    setDataFimLocal(formatar(fim));

  };

  const handlePeriodoChange = (e) => {
    const value = e.target.value;
    setPeriodo(value);
    aplicarPeriodo(value);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <Badge
          color="primary"
          variant="dot"
          invisible={!props?.dataInicio || !props?.dataFim}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} maxWidth={220}>

          {/* Períodos rápidos */}
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Período</InputLabel>

            <Select
              defaultValue={periodo}
              label="Período"
              onChange={handlePeriodoChange}
            >
              <MenuItem value="">Personalizado</MenuItem>

              {/* NOVOS */}
              <MenuItem value="hoje">Hoje</MenuItem>
              <MenuItem value="ontem">Ontem</MenuItem>
              <MenuItem value="7dias">Últimos 7 dias</MenuItem>
              <MenuItem value="30dias">Últimos 30 dias</MenuItem>

              {/* existentes */}
              <MenuItem value="semana">Esta semana</MenuItem>
              <MenuItem value="mes">Este mês</MenuItem>
              <MenuItem value="trimestre">Este trimestre</MenuItem>
              <MenuItem value="semestre">Este semestre</MenuItem>
            </Select>
          </FormControl>

          {/* Ano */}
          {props?.anosFiltro && (
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <InputLabel>Ano</InputLabel>
              <Select
                value={props?.anos ?? ""}
                label="Ano"
                onChange={props?.selecionaAno}
              >
                {props?.anosFiltro.map((ano) => (
                  <MenuItem key={ano} value={ano}>
                    {ano}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* Data Inicial */}
          <TextField
            fullWidth
            sx={{ mb: 2 }}
            type="date"
            label="Data Inicial"
            size="small"
            onChange={(e) => {
              setPeriodo(""); // limpa seleção automática
              props.setDataInicio(e.target.value);
            }}
            value={props.dataInicio || ""}
            InputLabelProps={{ shrink: true }}
          />

          {/* Data Final */}
          <TextField
            fullWidth
            type="date"
            label="Data Final"
            size="small"
            onChange={(e) => {
              setPeriodo(""); // limpa seleção automática
              props.setDataFim(e.target.value);
            }}
            value={props.dataFim || ""}
            InputLabelProps={{ shrink: true }}
          />

          {/* INDICAÇÃO DO PERÍODO SELECIONADO */}
          {(dataInicioLocal && dataFimLocal) && (
            <Box my={2} p={1} bgcolor="#f0f0f0" borderRadius={1}>
              Período selecionado:
              <br />
              <b>{dataInicioLocal + ' até ' + dataFimLocal}</b>
            </Box>
          )}
        </Box>
      </Popover>
    </Stack>
  );
}